module.exports = __webpack_public_path__ + "images/star5c7e258844a3f2b4245884e00428e7774.gif";